export default "__VITE_ASSET__ub6skz8W__"